import { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import style from "./Modal.module.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../button/PrimaryButton";
import SecondaryButton from "../button/SecondaryButton";
import { authActions } from "../../store/reducer/authReducer";
import { GROLOG_URL } from "../../constant/apiConstant";
import ModalSuccessDelete from "./ModalSuccessDelete";
import ModalFailedDelete from "./ModalFailedDelete";
import { Modal } from "antd";

const Delete = (props) => {
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState("");
  let dispatch = useDispatch();
  let { t } = useTranslation();
  const navigate = useNavigate();
  const form = {
    updated_at: props.data,
  };
  const formDriver = {
    updated_at_driver: props.data,
  };

  const doDelete = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url =
      props.url === "order"||props.url === "filter"
        ? process.env.REACT_APP_GROLOG_URL + "order/v1/grolog" + endpoint
        : GROLOG_URL + endpoint;
    const method = "DELETE";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };
  const deleteHandler = async () => {
    let data = props.url === "driver" ? formDriver : form;
    try {
      let res = await doDelete(
        `/${props.url}/${props.id}?${props.param}`,
        props.token,
        data
      );
      // if(res?.status === 200){
      setSuccessModalOpen(true);
    } catch (err) {
      // }else{
      setDeleteMessage(err.response.data.payload.message);
      setFailedModalOpen(true);
      console.log("cek", err.response.data.payload.message);
      // }
    }

    dispatch(authActions.refreshPage(1));
    dispatch(authActions.refreshPage(1));
    props.action();
    props.refresh();
    navigate(props.route, { state: false });
  };

  const actionOk = () => {
    setSuccessModalOpen(false);
    navigate(props.route, { state: false });
  };

  return (
    <>
      <ModalFailedDelete
        show={failedModalOpen}
        action={() => setFailedModalOpen(false)}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be deleted"
        description={deleteMessage}
      />

      <ModalSuccessDelete
        show={successModalOpen}
        action={() => actionOk()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description="Your data has been deleted"
      />
      <Modal
        visible={props.delete}
        closable={false}
        centered={true}
        width="464px"
        footer={null}
      >
        <div className={style.ModalTitle}>Delete Data?</div>
        <div className={style.ModalSubTitle}>
          Are you sure for delete
          <br />
          {props.id} - {props.title}?
        </div>

        <div
          style={{
            justifyItems: "center",
            margin: 0,
            padding: 0,
            display: "flex",
          }}
        >
          <div className="mr-8 ml-9">
            <SecondaryButton
              text={t("Yes, delete")}
              action={
                props.ops === "ops" ? () => props.act() : () => deleteHandler()
              }
            />
          </div>

          <PrimaryButton
            text={t("USER_DETAIL:CANCEL")}
            action={() => props.action()}
          />
        </div>
      </Modal>
    </>
  );
};

export default Delete;
